import React, { useState } from 'react';
import Icon from '@hubins/components/IconNew';
import __ from 'localisation';
import Button from '@hubins/components/Button';
import { useMiddleman } from '@hubins/middleman';

interface PreviewLinkProps {
  name: string;
  url: string;
  icon: string;
  small?: boolean;
  onlyIcon?: boolean;
  hideName?: boolean;
}

let urls = new WeakMap();

let blobUrl = blob => {
  if (urls.has(blob)) {
    return urls.get(blob);
  } else {
    let url = URL.createObjectURL(blob);
    urls.set(blob, url);
    return url;
  }
};

const PreviewLink = ({
  name = '',
  url = '',
  icon = 'View 1 by Streamlinehq',
  small = false,
  onlyIcon = false,
  hideName = false
}: PreviewLinkProps) => {
  const middleman = useMiddleman();


  const [downloading, setDownloading] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const [file, setFile] = useState<Blob | null>(null);

  // Start downloading the raw data when clicking the link
  // e: event
  // name: this.props.name
  const onClickPreview = (e: React.MouseEvent<HTMLButtonElement>, url: string, filename: string) => {
    e.preventDefault();

    setDownloading(true);

    fetch(e, url, filename);
  }

  const previewFile = (blob: string) => {
    window.open(blob, '_blank');
  };

  const fetch = (e, url, filename) => {
    let file: Blob | null = null;

    if (!downloaded) {
        middleman.getBlob(url).then((response) => {
        file = response.data as Blob;
        if (typeof file !== "undefined") {
          
          setDownloaded(true);
          setDownloading(false);
          setFile(file);

          previewFile(blobUrl(file));
        }
      }).catch(err => {
        console.log("Error fetching file", err);
        setDownloading(false);
      });
    }
    else {
      previewFile(blobUrl(file));
    }
  }

  return (
    <Button
      onClick={(e) => onClickPreview(e, url, name)}
      onlyIcon={onlyIcon}
      className={`${onlyIcon ? '' : ''} ${(!small && !onlyIcon) && 'button withicon withicon--left spacing '}`}
    >
      {hideName ? '' : name}
      {!downloading && !downloaded &&
        <Icon
          icon={icon}
          size={16}
          label={__('download_file') + ': '}
        />
      }
      {downloading && !downloaded &&
        <Icon
          icon="loading"
          size={16}
          label={__('loading')}
        />
      }
      {downloaded &&
        <Icon
          icon={icon}
          color="primary"
          size={16}
          label={__('download_file') + ': '}
        />
      }
    </Button>
  );
}

export default PreviewLink;
